
import { Vue, Watch, Component } from 'vue-property-decorator'
import { FileUrl } from '@/utils/commons'
import util from '@/utils/busi/util'
import { LocalStorage } from '@/utils/storage'
import { addadvertisingUpdate } from '@/api/enrollmentinformation'
import HsPlupload from '@/components/plupload/main.vue'
@Component({
  name: 'add-advertising',
  components: {
    HsPlupload
  }
})
export default class AddAdvertising extends Vue {
  private form = util.getRouterParams()

  private picList: any[] = this.form.images

  private up: any = {}

  private files = []

  private changed = !1

  private serverConfigUrl = 'http://localhost:9529/'

  @Watch('changed')
  private changeChanged () {
    const picList: any[] = []
    this.form.images && picList.push(...this.form.images)
    this.files.forEach((e: any) => {
      picList.push({ src: e.imgsrc, file: e })
    })
    this.picList = picList
  }

  private inputUploader (up: any) {
    this.up = up
    this.files = up.files
  }

  private filesAdded (up: any, files: any) {
    if (files.length > 1) {
      this.$message.error('每次只允许选择一张图片')
      return
    }
    files.forEach((f: any) => {
      // eslint-disable-next-line handle-callback-err
      FileUrl(f.getNative(), (err: any, imgsrc: any) => {
        f.imgsrc = imgsrc
        this.changed = !this.changed
      })
    })
  }

  private delPic (i: any) {
    if (this.picList && this.picList[i]) {
      this.up.removeFile(this.picList[i].file)
      this.picList.splice(i, 1)
    }
  }

  private onBack () {
    this.$router.push({
      name: 'advertisinglist'
    })
  }

  private async onSave () {
    await addadvertisingUpdate({
      ...this.form
    }).then((res: any) => {
      if (res.code === 10000) {
        this.form.images = this.picList
        const save = LocalStorage.getObj('addAdvertising')
        const list: any = [{ ...this.form }]
        save.list.map((v: any) => {
          if (v.id !== this.form.id) {
            list.push(v)
          }
        })
        save.list = list
        LocalStorage.setObj('addAdvertising', save)
        this.$message(res.message)
      }
    })
  }
}
